import { render, staticRenderFns } from "./jindieextra.vue?vue&type=template&id=0a4d3c3c&scoped=true&"
import script from "./jindieextra.vue?vue&type=script&lang=js&"
export * from "./jindieextra.vue?vue&type=script&lang=js&"
import style0 from "./jindieextra.vue?vue&type=style&index=0&id=0a4d3c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d3c3c",
  null
  
)

export default component.exports